<template>
  <a
    :href="resultUrl"
    :title="result.label"
    @click.stop
  >
    <DuiBookCover :book-cover-url="result.cover_url" />
    <span class="result-info">
      <DHighlightText
        class="result-label"
        :highlight="searchTerm"
        :text="result.label"
      />
      <span class="more-info">{{ result.author_name }}</span>
    </span>
  </a>
</template>

<script>
import searchResultMixin from '../search-result-mixin';

export default {
  mixins: [
    searchResultMixin,
  ],
};
</script>

<style lang="scss" scoped>
@import "@dui-styles/base";

.dui-book-cover {
  border-radius: $border-radius-xs;
  height: $book-cover-height-thumb;
  width: $book-cover-width-thumb;

  &.square {
    height: $book-cover-width-thumb;
  }
}
</style>
